/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';

/**
 * region for styles*/
import { textResponseStyle } from './style/textResponseStyle';

class TextResponse extends Component {
    render() {
        const { classes } = this.props;
        return (
            <Grid item xs={12} className={classes.contentInitalTextSearch}>
                <Typography variant="body1">
                    {this.props.text}
                </Typography>
            </Grid>
        );
    }
}
TextResponse.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(textResponseStyle)(TextResponse);





